<template>
  <a @click="openNewCoachModal"
     class="button is-primary is-medium is-fullwidth">
    <span class="icon">
      <i class="fa fa-plus"></i>
    </span>
    <span>Criar</span>
  </a>
</template>

<script>
  import Vue from 'vue'
  import CardModal from './CoachEditModal'

  const CardModalComponent = Vue.extend(CardModal)

  export default {
    data () {
      return {
      }
    },

    methods: {
      openNewCoachModal () {
        let openCardModal = (propsData = {}) => {
          return new CardModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Novo Coche',
          coachData: null
        })
      }
    }
  }
</script>

<style lang="scss">
  
</style>


// WEBPACK FOOTER //
// CoachNew.vue?11d2dcfc